<template>
  <div>
    <div v-if="showWxfwhImg" style="width: 100%; height: auto; text-align: center;">
      <h3>请您识别下方二维码</h3>
      <h3>先关注御茶膳房服务号</h3>
      <img src="@/assets/wxfwh.jpeg" style="width: 258px;" />
    </div>
    <div v-if="showYouzanImg" style="width: 100%; height: auto; text-align: center;">
      <h3>请您识别下方二维码</h3>
      <h3>先授权注册成为御茶膳房会员</h3>
      <img src="@/assets/youzan.jpeg" style="width: 258px;" />
    </div>
  </div>
</template>
<script>
import Vconsole from 'vconsole'
import { wxfwhGetMemberInfo } from '@/api/wx-fwh'
export default {
  name: 'WxPlayGameIndex',
  data() {
    return {
      showWxfwhImg: false,
      showYouzanImg: false
    }
  },
  async created() {
    const vConsole = new Vconsole()
    const code = this.Utils.getUrlKey('code')
    console.log('code: ', code)
    if (code) {
      await this.$store.dispatch('user/wxfwhLogin', code)
        .then(async(resp) => {
          if (resp.success) {
            wxfwhGetMemberInfo().then(resp => {
              console.log('resp: ', resp)
            })
            console.log('obj: ', resp.obj)
          } else {
            if (resp.msg === '10001') { // 未关注服务号
              this.showWxfwhImg = true
              this.showYouzanImg = false
            } else if (resp.msg === '10002') { // 未授权有赞
              this.showWxfwhImg = false
              this.showYouzanImg = true
            } else {
              this.alert('响应码错误，请您联系客服人员')
              this.showWxfwhImg = false
              this.showYouzanImg = false
            }
          }
        })
        .catch(() => {
          this.alert('验证身份失败，请您重新从微信服务号进入')
        })
    } else {
      this.alert('您的身份为空，请您从微信服务号进入')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wxfwh/play-game/index.vue